import React, { useEffect } from "react";
import "./ExportLabel.css";
import "../../common/CommonText.css";
import axios from "axios";
import { showAlert } from "../ErrorAlert/ErrorAlert";
import { useTranslation } from "react-i18next";

const ExportLabel = ({
  exportUrl,
  selectedIds,
  onExportStart,
  onExportComplete,
  onExportError,
}) => {
  const { t } = useTranslation();

  const handleExport = async () => {
    if (!selectedIds?.length) {
      showAlert(t("Please select the records to export."));
      return;
    }

    try {
      onExportStart?.();

      const response = await axios.post(
        exportUrl,
        { id_list: selectedIds },
        {
          responseType: "blob",
          headers: { "Content-Type": "application/json" },
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Generate filename from URL
      const filename = exportUrl.split("/").filter(Boolean).slice(-2).join("_");
      link.setAttribute("download", `${filename}.xlsx`);

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      onExportComplete?.();
    } catch (error) {
      onExportError?.(error);
      showAlert(t("Failed to export data. Please try again."));
    }
  };
  return (
    <div className="export" onClick={handleExport}>
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.2927 15.8232C12.4437 15.9739 12.6882 15.9738 12.839 15.823L14.0615 14.6005C14.4433 14.2187 15.096 14.4891 15.096 15.029V15.25C15.096 15.4626 15.2684 15.635 15.481 15.635C15.6936 15.635 15.866 15.4626 15.866 15.25V13.9425C15.866 13.0078 15.1082 12.25 14.1735 12.25H12.865C12.6524 12.25 12.48 12.4224 12.48 12.635C12.48 12.8476 12.6524 13.02 12.865 13.02H13.086C13.6259 13.02 13.8963 13.6727 13.5145 14.0545L12.2925 15.2765C12.1415 15.4275 12.1416 15.6724 12.2927 15.8232ZM14 18.116C12.886 18.116 11.941 17.7277 11.165 16.951C10.3883 16.175 10 15.23 10 14.116C10 13.002 10.3883 12.0567 11.165 11.28C11.9417 10.5033 12.8867 10.1153 14 10.116C15.1133 10.1167 16.0587 10.5047 16.836 11.28C17.6133 12.0553 18.0013 13.0007 18 14.116C18 15.2293 17.612 16.1743 16.836 16.951C16.0587 17.7277 15.1133 18.116 14 18.116ZM3.5 4.23C3.5 4.50614 3.72386 4.73 4 4.73H12C12.2761 4.73 12.5 4.50614 12.5 4.23C12.5 3.95386 12.2761 3.73 12 3.73H4C3.72386 3.73 3.5 3.95386 3.5 4.23ZM7.285 15.009C7.3327 15.494 6.98598 16 6.49864 16H1.616C1.168 16 0.786667 15.8427 0.472 15.528C0.157333 15.2133 0 14.8323 0 14.385V1.615C0 1.16833 0.157333 0.787333 0.472 0.472C0.786667 0.157333 1.168 0 1.616 0H14.385C14.8317 0 15.2127 0.157333 15.528 0.472C15.8427 0.786667 16 1.168 16 1.616V6.54394C16 7.04942 15.5066 7.4081 15.009 7.319C14.677 7.26033 14.3407 7.231 14 7.231C13.6627 7.231 13.3347 7.25767 13.016 7.311C12.705 7.36316 12.3988 7.43636 12.0974 7.5306C12.0873 7.53375 12.077 7.52622 12.077 7.51565C12.077 7.50701 12.07 7.5 12.0614 7.5H4C3.72386 7.5 3.5 7.72386 3.5 8C3.5 8.27614 3.72386 8.5 4 8.5H8.2726C8.82594 8.5 9.10526 9.29463 8.755 9.723C8.73066 9.75277 8.7066 9.78273 8.6828 9.81287C8.04202 10.6249 7.14214 11.269 6.10774 11.269H4C3.72386 11.269 3.5 11.4929 3.5 11.769C3.5 12.0451 3.72386 12.269 4 12.269H6.58999C7.03103 12.269 7.35295 12.6853 7.291 13.122C7.251 13.4087 7.231 13.7013 7.231 14C7.231 14.3067 7.249 14.643 7.285 15.009Z"
          fill="#094C80"
        />
      </svg>
      <span className="page-name normal-text">{t("Export")}</span>
    </div>
  );
};

export default ExportLabel;
